package dev.lingvo.shared.screenshots.doc

/**
 * The font families a v1 document may name (SPEC-B 7.1 templates, 8.1 script fallbacks, 8.2 extras).
 *
 * A family string ends up inside a canvas `font` declaration, so a document may only name a family from this list
 * and never inject CSS. B8's `FontCatalog` adds roles, scripts and weights; its coverage test must keep it equal to
 * this set, because a family dropped later would refuse documents saved today.
 */
object DesignFonts {
    val V1_NAMES: Set<String> = setOf(
        // Template families (7.1).
        "Inter Tight", "Fraunces", "Inter", "IBM Plex Mono", "Bricolage Grotesque", "Plus Jakarta Sans",
        "Manrope", "Space Grotesk", "Instrument Serif",
        // Script fallbacks (8.1).
        "Noto Sans", "Noto Serif", "Be Vietnam Pro", "PT Serif",
        "Noto Sans Arabic", "Noto Naskh Arabic", "Noto Kufi Arabic", "Noto Nastaliq Urdu",
        "Noto Sans Hebrew", "Noto Serif Hebrew", "Rubik",
        "Noto Sans Devanagari", "Noto Serif Devanagari", "Mukta",
        "Noto Sans Bengali", "Noto Serif Bengali", "Hind Siliguri",
        "Noto Sans Gujarati", "Noto Serif Gujarati", "Noto Sans Gurmukhi", "Noto Serif Gurmukhi",
        "Noto Sans Kannada", "Noto Serif Kannada", "Noto Sans Malayalam", "Noto Serif Malayalam",
        "Noto Sans Tamil", "Noto Serif Tamil", "Noto Sans Telugu", "Noto Serif Telugu",
        "Noto Sans Thai", "Noto Serif Thai", "Kanit",
        "Noto Sans Khmer", "Noto Serif Khmer", "Kantumruy Pro",
        "Noto Sans Myanmar", "Noto Serif Myanmar", "Padauk",
        "Noto Sans SC", "Noto Serif SC", "Noto Sans TC", "Noto Serif TC", "Noto Sans HK", "Noto Serif HK",
        "Noto Sans JP", "Noto Serif JP", "Zen Kaku Gothic New",
        "Noto Sans KR", "Noto Serif KR", "IBM Plex Sans KR",
        "Noto Color Emoji",
        // Extras (8.2).
        "Instrument Sans", "DM Sans", "Sora", "Outfit", "Playfair Display", "Newsreader",
        "Amiri", "Cairo", "Tajawal", "Heebo",
    )

    /** The rule the validator uses until B8's catalog is bound. Exact, case-sensitive names. */
    val V1: FontNameRule = FontNameRule { it in V1_NAMES }
}
